import Markup from '../components/Markup.tsx'
import BlankPage from '../components/BlankPage.tsx'
import Seo from '../components/Seo.tsx'
import * as home from '../content/home.ts'

export function HomeSection1() {
  return <Markup html={home.homeSection1} />
}
export function HomeSection2() {
  return <Markup html={home.homeSection2} />
}
export function HomeSection3() {
  return <Markup html={home.homeSection3} />
}
export function HomeSection4() {
  return <Markup html={home.homeSection4} />
}

export default function Home() {
  return (
    <>
      <Seo path="/" image="/assets/images/2017/07/front-page-marquee-EMMY.webp" />
      <BlankPage
        articleId="post-967"
        articleClass="post-967 page type-page status-publish hentry no-post-thumbnail"
        html={home.homeSection1 + home.homeSection2 + home.homeSection3 + home.homeSection4}
      />
    </>
  )
}
